import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  Show,
  Filter,
  Pagination,
  SimpleShowLayout,
  ReferenceInput,
  SelectInput,
  ReferenceField,
  BooleanInput,
  DateField,
  ShowButton,
  TextInput,
  DateInput,
  useRecordContext
} from 'react-admin';
import Grid from '@mui/material/Grid';
import { ProjectField, ProjectInput } from '../components/projectInput';
import { AutomationInput, AutomationField } from '../components/triggerEditor'


const CrashFilter = (props) => (
  <Filter {...props}>
      <ProjectInput source="fk_project" alwaysOn filterMode />
	  <TextInput source="__like__type" label="Type" alwaysOn />
	  <TextInput source="__like__error" label="Error" alwaysOn />
	  <TextInput source="__like__identity" label="Identity" />
	  <TextInput source="__like__version" label="Version" />
	  <DateInput source="created[$lt]" label="Reported before" />
	<DateInput source="created[$gt]" label="Reported after" />
  </Filter>
);

const MaybeJsonField = (props) => {
  const record = useRecordContext();
  
  let meta = "";
  try { meta = JSON.stringify(JSON.parse(record[props.source]), null, 2); } catch { meta = record[props.source]; }
  
  return (
    <pre {...props}>{meta}</pre>
  );
};

const CrashPagination = (props) => (
  <Pagination rowsPerPageOptions={[50, 100, 200, 500]} {...props} />
);

export const CrashList = (props) => (
  <List
    {...props}
    filters={<CrashFilter />}
    pagination={<CrashPagination />}
    perPage={50}
  >
    <Datagrid>
	  <DateField source="created" label="Reported" showTime />
      <ProjectField source="fk_project" label="Project" />	  
	  <TextField source="version" />
	  <TextField source="identity" />
	  <TextField source="type" />
	  <TextField source="error" />
      <ShowButton />
    </Datagrid>
  </List>
);

export const CrashShow = (props) => (
	<Show {...props}>
		<SimpleShowLayout>
		
		<Grid container spacing={2} className="hide-sublabel">
			
			
			<Grid item md={4}>
				<span className="field-label">Project</span>
				<div className="field-value">
					<ProjectField source="fk_project" />
				</div>
			</Grid>
			
			<Grid item md={4}>
				<span className="field-label">Type</span>
				<TextField source="type" className="field-value" />
			</Grid>
			
			<Grid item md={4}>
				<span className="field-label">Version</span>
				<TextField source="version" className="field-value" />
			</Grid>
			
		</Grid>
		
		<Grid container spacing={2} className="hide-sublabel">
		
			<Grid item md={4}>
				<span className="field-label">Reported</span>
				<DateField source="created" className="field-value" showTime />
			</Grid>
		
			<Grid item md={4}>
				<span className="field-label">Identity</span>
				<TextField source="identity" className="field-value" />
			</Grid>
			
			<Grid item md={4}>
				<span className="field-label">ID</span>
				<TextField source="id" className="field-value" />
			</Grid>
		</Grid>
		
	  <TextField source="error" />
	  <MaybeJsonField source="detail" />
	  <MaybeJsonField source="config" />
	  <TextField source="description" />
	  <AutomationField label="Automations" type="crashes" />
		</SimpleShowLayout>
	</Show>
);